import React, { useEffect, useContext } from 'react';
import { withRouter } from 'react-router-dom';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import _ from 'lodash';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import { getJson } from 'session';
import { Acl } from 'modules/common/components/Acl';
import TransactionInformation from 'modules/common/components/TransactionInformation';
import ImagePlaceholder from 'assets/img/image-placeholder.jpg';
import VerifyReceipt from '../component/VerifyReceipt';
import ViewORModal from '../component/ViewORModal';
import * as actions from '../action';
import * as c from '../constant';

function ApplicationContent({
  transactionInfo,
  showTransaction,
  clearTransaction,
  isLoading,
  match,
  taxpayer,
}) {
  const setModal = useContext(ModalContext);
  const selectedTransaction = match.params.id;
  const permissions = getJson('permissions');

  const showVerifyReceipt = status => {
    return [
      'WAITING FOR PAYMENT',
      'PAID',
      'FOR PICK-UP',
      'PENDING',
      'EXPIRED REFERENCE NUMBER',
    ].includes(status);
  };

  const updateData = () => {
    showTransaction(selectedTransaction);
  };

  useEffect(() => {
    if (!_.isEmpty(selectedTransaction)) {
      updateData();
    }
    return () => {
      clearTransaction();
    };
  }, []);

  useEffect(() => {
    if (!_.isEmpty(selectedTransaction)) {
      updateData();
    }
  }, [selectedTransaction]);

  const getInitials = cString => {
    if (cString) {
      const val = cString.replace(/\[^a-zA-Z- ]/g, '').match(/\b(\w)/g);
      const strFirstTwo = val.slice(0, 2);
      const final = strFirstTwo.join('');
      return final.toUpperCase();
    }
    return null;
  };

  const handleVerifyReceipt = e => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: (
        <VerifyReceipt
          transactionInfo={transactionInfo}
          id={selectedTransaction}
        />
      ),
      title: `Assess Payment Receipt`,
      modalSize: 'modal-md',
    });
  };

  const handleViewOR = e => {
    e.preventDefault();

    setModal({
      isOpen: true,
      content: <ViewORModal data={transactionInfo} id={selectedTransaction} />,
      title: 'View OR',
      modalSize: 'modal-xl',
    });
  };

  const isEmployed = _.get(taxpayer, 'is_employed_individual');
  const tStatus = _.get(transactionInfo, 'attributes.transaction_status');

  return (
    <>
      <div className="card-section-content container-fluid">
        {isLoading && (
          <div className="loading">
            <div className="spinner text-center">
              <span className="fas fa-1x fa-spin fa-spinner" />
            </div>
          </div>
        )}
        <div className="right-section-content">
          {/* GRAY HIGHLIGHT */}
          <div className="row highlight d-flex align-items-center mx-3 py-3">
            <div className="col-12 px-0 mt-0 mb-1">
              {/* BORDER */}
              <div className="card border-primary">
                <div className="container-fluid py-1">
                  <div className="p-0 d-flex flex-nowrap mb-3 w-100">
                    <div className="d-flex round-image justify-content-center">
                      <h3 className="d-flex align-items-center initials mb-0">
                        {getInitials(
                          `${_.get(taxpayer, 'first_name')} ${_.get(
                            taxpayer,
                            'middle_name'
                          )} ${_.get(taxpayer, 'last_name')}`
                        )}
                      </h3>
                    </div>
                    <div className="d-flex ml-4 align-items-center">
                      <h1 className="transaction-company m-0">
                        {`${_.get(taxpayer, 'first_name') || '-'} ${_.get(
                          taxpayer,
                          'middle_name'
                        ) || ''} ${_.get(taxpayer, 'last_name') || ''} ${_.get(
                          taxpayer,
                          'extension_name'
                        ) || ''}`}
                      </h1>
                    </div>
                  </div>
                  <div className="d-flex ml-auto justify-content-end mb-3">
                    {Acl(permissions, ['MISCELLANEOUS FEES ASSESS PAYMENT RECEIPT']) && 
                      showVerifyReceipt(tStatus) ? (
                        <button
                          type="button"
                          className="btn gen-btn font-weight-bold btn-primary cms-bg-color-primary cms-outline-primary"
                          onClick={handleVerifyReceipt}
                        >
                          Assess Payment Receipt
                        </button>
                      ) : (
                        ''
                    )}                         
                    {Acl(permissions, ['MISCELLANEOUS FEES VIEW OR']) && 
                      _.get(transactionInfo, 'attributes.status') === 'PAID' ? (
                        <button
                          type="button"
                          className="btn gen-btn font-weight-bold btn-primary cms-bg-color-primary cms-outline-primary ml-2"
                          onClick={handleViewOR}
                        >
                          View OR
                        </button>
                      ) : (
                        ''
                    )}
                  </div>
                  <Tabs>
                    <TabList>
                      <Tab>Transaction</Tab>
                      <Tab>Information</Tab>
                    </TabList>
                    <TabPanel>
                      <TransactionInformation
                        module="mf"
                        transactionInfo={transactionInfo}
                        taxpayer={taxpayer}
                      />
                    </TabPanel>
                    <TabPanel>
                      <div className="col-12 p-3">
                        <table className="transaction-table table table-borderless table-striped table-sm ">
                          <tbody>
                            <tr>
                              <td className="span-title2 font-weight-bold" width="250">
                                Office
                              </td>
                              <td className="text-dark" width="1">
                                :
                              </td>
                              <td>
                                <b>
                                  {(
                                    _.get(transactionInfo, 'included.module.attributes.office_name') || '--'
                                  ).toUpperCase()}
                                </b>
                              </td>
                            </tr>
                            <tr>
                              <td className="span-title2 font-weight-bold" width="250">
                                Miscellaneous Fee
                              </td>
                              <td className="text-dark" width="1">
                                :
                              </td>
                              <td>
                                <b>
                                  {(
                                    _.get(transactionInfo, 'included.module.attributes.miscellaneous_fee_name') || '--'
                                  ).toUpperCase()}
                                </b>
                              </td>
                            </tr>
                            <tr>
                              <td className="span-title2 font-weight-bold" width="250">
                                Amount
                              </td>
                              <td className="text-dark" width="1">
                                :
                              </td>
                              <td>
                                <b>
                                  {'\u20B1'}{' '}{(
                                    _.get(transactionInfo, 'included.module.attributes.amount') || '--'
                                  ).toUpperCase()}
                                </b>
                              </td>
                            </tr>
                            <tr className="mb-2">
                              <td className="span-title2 font-weight-bold" width="250">
                                Remarks
                              </td>
                              <td className="text-dark" width="1">
                                :
                              </td>
                              <td>
                                <b>
                                  {(
                                    _.get(transactionInfo, 'included.module.attributes.remarks') || '--'
                                  ).toUpperCase()}
                                </b>
                              </td>
                            </tr>
                            <tr>
                              <td className="span-title2 font-weight-bold" width="250">
                                Last Name
                              </td>
                              <td className="text-dark" width="1">
                                :
                              </td>
                              <td>
                                <b>
                                  {(
                                    _.get(taxpayer, 'last_name') || '--'
                                  ).toUpperCase()}
                                </b>
                              </td>
                            </tr>
                            <tr>
                              <td className="span-title2 font-weight-bold" width="250">
                                First Name
                              </td>
                              <td className="text-dark" width="1">
                                :
                              </td>
                              <td>
                                <b>
                                  {(
                                    _.get(taxpayer, 'first_name') || '--'
                                  ).toUpperCase()}
                                </b>
                              </td>
                            </tr>
                            <tr>
                              <td className="span-title2 font-weight-bold" width="250">
                                Middle Name
                              </td>
                              <td className="text-dark" width="1">
                                :
                              </td>
                              <td>
                                <b>
                                  {(
                                    _.get(taxpayer, 'middle_name') || '--'
                                  ).toUpperCase()}
                                </b>
                              </td>
                            </tr>                        
                            <tr>
                              <td className="span-title2 font-weight-bold" width="250">
                                Extension Name
                              </td>
                              <td className="text-dark" width="1">
                                :
                              </td>
                              <td>
                                <b>
                                  {(
                                    _.get(taxpayer, 'extension_name') || '--'
                                  ).toUpperCase()}
                                </b>
                              </td>
                            </tr>
                            <tr>
                              <td className="span-title2 font-weight-bold" width="250">
                                Tax Payer Account No:
                              </td>
                              <td className="text-dark" width="1">
                                :
                              </td>
                              <td>
                                <b>
                                  {(
                                    _.get(
                                      taxpayer,
                                      'tax_payer_account_number'
                                    ) || '--'
                                  ).toUpperCase()}
                                </b>
                              </td>
                            </tr>
                            <tr>
                              <td className="span-title2 font-weight-bold" width="250">
                                Address
                              </td>
                              <td className="text-dark" width="1">
                                :
                              </td>
                              <td>
                                <b>
                                  {_.get(taxpayer, 'region_name') || '--'}
                                  {''}
                                  {_.get(taxpayer, 'province_name') ||
                                    '--'}{' '}
                                  {_.get(taxpayer, 'municipality_name') || '--'}{' '}
                                  {_.get(taxpayer, 'barangay_name') || '--'}{' '}
                                  {_.get(taxpayer, 'street') || '--'}
                                </b>
                              </td>
                            </tr>
                            <tr>
                              <td className="span-title2 font-weight-bold" width="250">
                                Is Employed
                              </td>
                              <td className="text-dark" width="1">
                                :
                              </td>
                              <td>
                                <b>{isEmployed ? 'YES' : 'NO'}</b>
                              </td>
                            </tr>
                            <tr>
                              <td className="span-title2 font-weight-bold" width="250">
                                Gender
                              </td>
                              <td className="text-dark" width="1">
                                :
                              </td>
                              <td>
                                <b>
                                  {(
                                    _.get(taxpayer, 'gender') || '--'
                                  ).toUpperCase()}
                                </b>
                              </td>
                            </tr>
                            <tr>
                              <td className="span-title2 font-weight-bold" width="250">
                                Civil Status
                              </td>
                              <td className="text-dark" width="1">
                                :
                              </td>
                              <td>
                                <b>
                                  {(
                                    _.get(taxpayer, 'civil_status') || '--'
                                  ).toUpperCase()}
                                </b>
                              </td>
                            </tr>
                            <tr>
                              <td className="span-title2 font-weight-bold" width="250">
                                Citizenship
                              </td>
                              <td className="text-dark" width="1">
                                :
                              </td>
                              <td>
                                <b>
                                  {(
                                    _.get(taxpayer, 'citizenship_name') || '--'
                                  ).toUpperCase()}
                                </b>
                              </td>
                            </tr>
                            <tr>
                              <td className="span-title2 font-weight-bold" width="250">
                                ACR No. (if alien)
                              </td>
                              <td className="text-dark" width="1">
                                :
                              </td>
                              <td>
                                <b>
                                  {(
                                    _.get(taxpayer, 'acr_number') || '--'
                                  ).toUpperCase()}
                                </b>
                              </td>
                            </tr>
                            <tr>
                              <td className="span-title2 font-weight-bold" width="250">
                                Place of Birth
                              </td>
                              <td className="text-dark" width="1">
                                :
                              </td>
                              <td>
                                <b>
                                  {(
                                    _.get(
                                      taxpayer,
                                      'place_of_birth_region_name'
                                    ) || '--'
                                  ).toUpperCase()}{' '}
                                  {(
                                    _.get(
                                      taxpayer,
                                      'place_of_birth_province_name'
                                    ) || '--'
                                  ).toUpperCase()}{' '}
                                  {(
                                    _.get(
                                      taxpayer,
                                      'place_of_birth_municipality_name'
                                    ) || '--'
                                  ).toUpperCase()}
                                </b>
                              </td>
                            </tr>
                            <tr>
                              <td className="span-title2 font-weight-bold" width="250">
                                Date of Birth
                              </td>
                              <td className="span-title2 font-weight-bold" width="1">
                                :
                              </td>
                              <td>
                                <b>{_.get(taxpayer, 'birth_date') || '--'}</b>
                              </td>
                            </tr>
                            <tr>
                              <td className="span-title2 font-weight-bold" width="250">
                                Profession/Occupation Business
                              </td>
                              <td className="text-dark" width="1">
                                :
                              </td>
                              <td>
                                <b>
                                  {(
                                    _.get(taxpayer, 'profession_name') || '--'
                                  ).toUpperCase()}
                                </b>
                              </td>
                            </tr>
                            <tr>
                              <td className="span-title2 font-weight-bold" width="250">
                                Height
                              </td>
                              <td className="text-dark" width="1">
                                :
                              </td>
                              <td>
                                <b>
                                  {(
                                    _.get(taxpayer, 'height') || '--'
                                  ).toUpperCase()}
                                </b>
                              </td>
                            </tr>
                            <tr>
                              <td className="span-title2 font-weight-bold" width="250">
                                Weight
                              </td>
                              <td className="text-dark" width="1">
                                :
                              </td>
                              <td>
                                <b>
                                  {(
                                    _.get(taxpayer, 'weight') || '--'
                                  ).toUpperCase()}
                                </b>
                              </td>
                            </tr>
                            <tr>
                              <td className="span-title2 font-weight-bold" width="250">
                                Residence Tax Due
                              </td>
                              <td className="text-dark" width="1">
                                :
                              </td>
                              <td>
                                <b>
                                  {_.get(taxpayer, 'residence_tax_due') || '--'}
                                </b>
                              </td>
                            </tr>
                            <tr>
                              <td className="span-title2 font-weight-bold" width="250">
                                Uploaded Image
                              </td>
                              <td className="text-dark" width="1">
                                :
                              </td>
                              <td>
                                <img 
                                  src={
                                    !_.isObject(_.get(transactionInfo, 'included.module.attributes.image_url') || '')
                                      ? _.get(transactionInfo, 'included.module.attributes.image_url') || ImagePlaceholder
                                      : _.get(transactionInfo, 'included.module.attributes.image_url.cdnUrl') || ImagePlaceholder
                                  }
                                  alt="image_url"
                                  className="w-100 rounded"
                                />
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </TabPanel>
                  </Tabs>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

ApplicationContent.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
  taxpayer: PropTypes.instanceOf(Object).isRequired,
  showTransaction: PropTypes.instanceOf(Function).isRequired,
  transactionInfo: PropTypes.instanceOf(Object).isRequired,
  clearTransaction: PropTypes.instanceOf(Function).isRequired,
  isLoading: PropTypes.bool.isRequired,
};

const mapStateToProps = ({ api }) => ({
  transactionInfo: _.get(api, `${c.SHOW_TRANSACTION}.item`) || {},
  taxpayer:
    {
      ...(_.get(
        api,
        `${c.SHOW_TRANSACTION}.item.included.taxPayer.attributes`
      ) || {}),
    } || {},
  isLoading: api.loading.indexOf(c.SHOW_TRANSACTION) > -1,
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(ApplicationContent);
